import type { EventTypes } from '@racemap/sdk/schema/events';
import type { EventState, PoiType, StarterType, TrackType } from 'src/lib/player/store';

export enum SideBarSection {
  FAVORITE = 'FAVORITE',
  EVENTS = 'EVENTS',
  POI = 'POI',
  TRACK = 'TRACK',
  STARTERS = 'STARTERS',
}

export enum SideBarItemType {
  HEADER = 'HEADER',
  EVENT = 'EVENT',
  STARTER = 'STARTER',
  STARTER_GROUP = 'STARTER_GROUP',
  STARTER_FILTER = 'STARTER_FILTER',
  STARTER_SORT = 'STARTER_SORT',
  POI = 'POI',
  TRACK = 'TRACK',
}

export type SideBarItem =
  | {
      type: SideBarItemType.HEADER;
      label:
        | SideBarSection.FAVORITE
        | SideBarSection.POI
        | SideBarSection.TRACK
        | SideBarSection.STARTERS;
    }
  | {
      type: SideBarItemType.HEADER;
      label: SideBarSection.EVENTS;
      eventType: EventTypes;
    }
  | { type: SideBarItemType.EVENT; event: EventState }
  | { type: SideBarItemType.STARTER; starter: StarterType; isFavorite?: boolean; group?: string }
  | { type: SideBarItemType.STARTER_GROUP; tagKey: string; tagValue: string }
  | { type: SideBarItemType.STARTER_FILTER; itemCount: number }
  | { type: SideBarItemType.STARTER_SORT }
  | { type: SideBarItemType.POI; poi: PoiType; isFavorite?: boolean }
  | { type: SideBarItemType.TRACK; track: TrackType; isFavorite?: boolean };

export enum SortKey {
  START_NUMBER = 'START_NUMBER',
  NAME = 'NAME',
  OFFSET = 'OFFSET',
}

export type SortDirection = 'ASC' | 'DESC';

export type StarterSorting = [SortKey, SortDirection];
